export const ARCHIVE = 'archive'
export const UNSUBSCRIBE = 'unsubscribe'
export const RESUBSCRIBE = 'resubscribe'
export const ACTIVE_COMMUNITY_NOT_FOUND_ERROR = 'Something went wrong. Active communityInfo doesn\'t found'
export const RETRY_LIMIT = 2
export const RETRY_WAIT_TIME = 5000